import { render, staticRenderFns } from "./ServiceNoticeDetail.vue?vue&type=template&id=65482018"
import script from "./ServiceNoticeDetail.vue?vue&type=script&lang=js"
export * from "./ServiceNoticeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports